import React from 'react';
import PropTypes from 'prop-types';

import {translate} from 'views/module';

import CompactDropdown from 'views/scenes/client/detail/client_scenes/client_feed/header/client_details/dropdowns/CompactDropdown';

const statusValueColors = {
  OPEN: '#D85D31',
  PENDING: '#B77900',
  COMPLETE: '#008A00',
  DELETED: '#6D7280',
};

const CaseStatusDropdown = (props) => {
  const {
    label,
    selectedStatus,
    setSelectedStatus,
  } = props;

  const statuses = ['OPEN', 'PENDING', 'COMPLETE', 'DELETED'];
  const selectedStatusLabel = selectedStatus ?
    translate(`case.Status.${selectedStatus}.Title`) :
    translate('case.Detail.EmptyValue');

  const handleOptionSelect = (selectedOption) => {
    if (!selectedOption || selectedOption === selectedStatus) {
      return;
    }

    setSelectedStatus(selectedOption);
  };

  return (
    <CompactDropdown
      getOptionKey={(option) => option}
      getOptionLabel={(option) => translate(`case.Status.${option}.Title`)}
      isOptionSelected={(option) => selectedStatus === option}
      label={label}
      menuLabel={label}
      onOptionSelect={handleOptionSelect}
      options={statuses}
      value={selectedStatusLabel}
      valueColor={statusValueColors[selectedStatus] || '#050A14'}
    />
  );
};

CaseStatusDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  selectedStatus: PropTypes.string,
  setSelectedStatus: PropTypes.func.isRequired,
};

export default React.memo(CaseStatusDropdown);
